import { render, staticRenderFns } from "./contactLead.vue?vue&type=template&id=227b8a92&"
import script from "./contactLead.vue?vue&type=script&lang=js&"
export * from "./contactLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports